import React, { useLayoutEffect } from 'react'

export default function RefundAndCancellationPolicy() {
  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <section className="pt-10 lg:pt-12 blade-bottom-padding-lg min-h-[300px] bg-blueGreen">
        <div className="text-center px-4 mt-6 md:mt-8 lg:mt-0">
          <div className="blade-top-padding blade-top-margin-sm pb-4">
            <h1 className="font-medium text-2xl text-white mxlg:text-3xl 2xl:text-4xl leading-tight">
              Refund and Cancellation Policy
            </h1>
          </div>
        </div>
      </section>

      <section className="w-container blade-top-padding-lg blade-bottom-padding-lg blade-bottom-margin-lg px-3 sm:px-5">
        <div className="max-w-5xl mx-auto text-blueGreen content-wrapper">
          <h4>Applicability</h4>
          <p>
            These Cancellation and Refund Terms are applicable to all types of
            digital payments made to or through Etribe Finance Private Limited.
          </p>

          <h4>Failed Transactions</h4>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              If an amount is debited from the customer&apos;s bank account,
              card, or wallet despite a failed transaction due to any reason,
              the onus shall be on the customer&apos;s bank, card issuer, or
              wallet provider to reverse the amount.
            </li>
          </ul>

          <h4>Duplicate or Excess Payments</h4>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              In the event that a customer has attempted to make an online
              payment more than once and Etribe Finance Private Limited has
              received the amount more than once, Etribe Finance Private Limited
              reserves the right to adjust such excess amount against additional
              EMI(s) towards the customer&apos;s loan account.
            </li>
            <li>
              If Etribe Finance Private Limited decides to refund the excess
              amount, it shall be processed through electronic mode within one
              (1) month from the date of claim acceptance.
            </li>
            <li>
              In the case of a customer holding more than one loan account,
              Etribe Finance Private Limited reserves the right to adjust the
              excess amount towards any one or more account(s) as it deems fit,
              irrespective of the bifurcation provided by the customer.
            </li>
          </ul>

          <h4>Refund Process</h4>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              The customer must submit a written application or send an email to
              Etribe Finance Private Limited requesting a refund, along with the
              transaction number and original payment receipt (if any) generated
              at the time of making the payment.
            </li>
            <li>
              The customer must claim any refund within seven (7) days of the
              date of payment.
            </li>
          </ul>

          <h4>Limitation of Liability</h4>
          <p>
            Etribe Finance Private Limited assumes no responsibility and shall
            incur no liability if it is unable to effect any Payment
            Instruction(s) on the Payment Date owing to any one or more of the
            following circumstances:
          </p>
          <ol>
            <li>
              The Payment Instruction(s) issued by the customer is/are
              incomplete, inaccurate, invalid, or delayed.
            </li>
            <li>
              The Payment Account has insufficient funds or limits to cover the
              amount as mentioned in the Payment Instruction(s).
            </li>
            <li>
              The funds available in the Payment Account are under any
              encumbrance or charge.
            </li>
            <li>
              The customer&apos;s bank refuses or delays honouring the Payment
              Instruction(s).
            </li>
            <li>
              Circumstances beyond the control of the Company, including but not
              limited to fire, flood, natural disasters, bank strikes, power
              failure, or systems failure such as computer or telephone line
              breakdown due to an unforeseeable cause or interference from an
              outside force.
            </li>
            <li>
              In the event the payment is not processed for any reason, the
              customer shall be intimated about the failed payment via email.
            </li>
          </ol>

          <h4>Suspension of Online Payment Services</h4>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              Etribe Finance Private Limited may, in its sole discretion and for
              any or no reason, suspend or terminate the use of online payment
              services from any payment gateway service provider.
            </li>
          </ul>
        </div>
      </section>
    </>
  )
}
